import { onBeforeMount, onBeforeUnmount, ref, unref, watch, type MaybeRef } from 'vue'

export function useSelection(targetEl: MaybeRef<HTMLTextAreaElement | HTMLInputElement | null>) {
  const selection = ref<{ start: number | null; end: number | null }>({ start: null, end: null })

  const abortController = new AbortController()

  const updateSelection = () => {
    const inputElVal = unref(targetEl)
    if (!inputElVal) return

    selection.value = {
      start: inputElVal.selectionStart,
      end: inputElVal.selectionEnd,
    }
  }

  onBeforeMount(() => {
    document.addEventListener('selectionchange', updateSelection, { signal: abortController.signal })
  })

  watch(
    () => unref(targetEl),
    targetElVal => {
      if (!targetElVal) return
      targetElVal.addEventListener('input', updateSelection)
    }
  )

  onBeforeUnmount(() => {
    abortController.abort()
  })

  return selection
}
